<template>
  <v-form>
    <v-card>
      <v-card-text>
        <v-text-field
          v-validate="'required|email'"
          data-vv-as="Email"
          data-vv-name="username"
          :error-messages="errors.collect('username')"
          prepend-icon="email"
          name="username"
          label="Email"
          type="email"
          autocomplete="email"
          v-model="login.username"
          @keyup.enter="submit"
          autofocus
        ></v-text-field>
        <v-text-field
          v-validate="'required'"
          :error-messages="errors.collect('loginPassword')"
          data-vv-as="Heslo"
          data-vv-name="loginPassword"
          prepend-icon="lock"
          name="password"
          label="Heslo"
          type="password"
          autocomplete="current-password"
          v-model="login.password"
          @keyup.enter="submit"
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-btn flat color="primary" @click="$router.push('/auth/forgotpassword')">
          <span>Zabudnuté heslo</span>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn :loading="loading" :disabled="loading" color="primary" @click.prevent="submit">
          <span>Prihlásiť</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import * as types from "@/store/types";
import Controller from "@/mixins/controlsMixins";
export default {
  mixins: [Controller],
  data() {
    return {
      loading: false,
      login: {
        username: "",
        password: ""
      }
    };
  },
  methods: {
    submit: function() {
      this.$validator.validate().then(result => {
        if (result) {
          this.loading = true;
          this.$store
            .dispatch(types.AUTH_LOGIN, this.login)
            .then(() => {
              this.$router.push({
                path: this.$route.query.redirect || "/"
              });
            })
            .catch(e => {
              if (e != null)
                this.openGlobalAlert(
                  "Prihlasovacie údaje sú nesprávne.",
                  "error"
                );
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    }
  }
};
</script>
<style>
</style>